"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePromise = void 0;
const react_1 = require("react");
const use_lazy_promise_1 = require("./use-lazy-promise");
const usePromise = (promiseFn, ...params) => {
    const { result, status, error, execute } = (0, use_lazy_promise_1.useLazyPromise)(promiseFn);
    (0, react_1.useEffect)(() => {
        execute(...params);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [execute, ...params]);
    return { result, status, error, refresh: execute };
};
exports.usePromise = usePromise;
